<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12dRps5/tc-custom/9780802199034.jpg?1706960728379" alt="This image is the cover for the book 120 Days of Sodom & Other Writings"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">120 Days of Sodom & Other Writings
      </h1>
      <p class="bookDescription body article font2">
        <b>The definitive compilation of texts from “a great, horrifying, but also vastly illuminating figure . . . one of the most radical minds in Western history” (<i>Newsweek</i>).</b><br/>  <br/> The Marquis de Sade, vilified by respectable society from his own time through ours, apotheosized by Apollinaire as “the freest spirit that has yet existed,” wrote <i>The 120 Days of Sodom</i> while imprisoned in the Bastille. An exhaustive catalogue of sexual aberrations and the first systematic exploration—a hundred years before Krafft-Ebing and Freud—of the psychology of sex, it is considered Sade’s crowning achievement and the cornerstone of his thought. Lost after the storming of the Bastille in 1789, it was later retrieved but remained unpublished until 1904.<br/>  <br/> In addition to <i>The 120 Days</i>, this volume includes Sade’s “Reflections on the Novel,” his play <i>Oxtiern</i>, and his novella <i>Ernestine</i>. The selections are introduced by Simone de Beauvoir’s landmark essay “Must We Burn Sade?” and Pierre Klossowski’s provocative “Nature as Destructive Principle.”<br/>  <br/> “Imperious, choleric, irascible, extreme in everything, with a dissolute imagination the like of which has never been seen, atheistic to the point of fanaticism, there you have me in a nutshell, and kill me again or take me as I am, for I shall not change.” —Marquis de Sade’s last will and testament
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marquis de Sade, Richard Seaver, Austryn Wainhouse
      </h2>
      
      <p class="authorDescription body article">The Marquis de Sade was born in Paris, France in 1740. He fought in the French Army during the Seven Years War before he was tried and sentenced to death in 1772 for a series of sexual crimes. He escaped to Italy, but upon his return to France in 1777, he was recaptured and thrown into the prison at Vincennes. De Sade spent six years at Vincennes before being transferred to the Bastille, then to Charenton, a lunatic asylum, in 1789. He was released from the asylum a year later but was arrested again in 1801. He was moved from prison to prison before returning to Charenton in 1803, where he later died in 1814. A French novelist and playwright, de Sade is largely known for his pathological sexual views and ethical nihilism. His works include <I>Justine</I>, <I>Philosophy in the Bedroom</I>, <I>Juliette</I>, and <I>Aline and Valcourt, Or The Philosophic Novel</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?10f6d45a